class Api {
    constructor(state) {
        this.config = state.bbConfig;
    }

    websiteKey() {
        return this.config.websiteKey;
    }

    domainToken() {
        return this.config.domainToken;
    }

    authHeaders() {
        return {
            'X-DOMAIN-TOKEN': this.domainToken()
        };
    }

    apiUrl() {
        return this.config.apiUrl;
    }

    fetch(path, options = {}) {
        return fetch(`${this.apiUrl()}/${path}`, {
            ...options,
            headers: {
                ...options.headers,
                ...this.authHeaders()
            }
        });
    }

    get(path) {
        return this.fetch(path);
    }

    post(path, body) {
        return this.fetch(path, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body)
        });
    }

    pusherAuthEndpoint() {
        return `${this.apiUrl()}/${this.websiteKey()}/conversation/auth`;
    }
}

export const getProactiveMessages = () => (dispatch, getState) => {
    const api = new Api(getState());
    return api.get(`${api.websiteKey()}/conversation/proactive_messages`)
        .then((response) => response.json());
};

export const trackEvent = (event) => (dispatch, getState) => {
    const api = new Api(getState());
    return api.post(`${api.websiteKey()}/events/track`, event)
        .then((response) => response.json());
};

export const api = (state) => new Api(state);


